<div class="location-info mb-5">
  <p class="h5 pl-2 position-absolute"><u>Clicca l'immagine per aprire su Google Maps</u></p>
  <a [href]=link target="_blank">
    <img class="w-100" src="../../assets/resources/maps2.png" alt="posizione google maps">
  </a>
</div>
